import gql from 'graphql-tag';
import { query } from '@/api/graphql';
import { getCurrentTime } from './graphql/GetIsoDateTime.graphql';

export const getCurrentDateTime = async () => {
  const { currentTime } = await query(gql`
  ${getCurrentTime}
  `);

  return currentTime;
};
